import { render } from "./loading.vue?vue&type=template&id=214716db&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=214716db&scoped=true&lang=css"

import exportComponent from "D:\\work\\webGl\\chery-ruihu9\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214716db"]])

export default __exports__